<section class="not-published-card">
  <img
    class="not-published-image"
    src="/images/publish-link.png"
    alt="Publish link illustration" />

  <div class="status-pill">Admission Link Status</div>

  <h1>Link Not Published Yet</h1>

  <p>
    The admission link for {{ schoolName }} is not published yet.
  </p>

  <p>
    Please contact the school administration for access or try again later.
  </p>
</section>

<footer class="screen-footer">
  Copyright © {{ currentYear }} Thoughtniques Technologies Pvt ltd.
</footer>
